import { Button } from "~/common/components/Button/Button";
import React, { useState, useEffect } from "react";
import { useGetMediaFiles } from "~/modules/app/models/app.hooks";
import { setSnackbar } from '~/modules/app/redux/app.actions';
import { useDispatch } from 'react-redux';

const FileTree = ({ files, onDownloadFile }) => {
  const renderTree = (nodes) => {
    return nodes.sort((a, b) => {
        if (a.type !== b.type) {
          return a.type === "directory" ? 1: -1;
        }
        return a.name.localeCompare(b.name);
      }).map((node, index) => {
      if (node.type === "directory") {
        return (
          <div key={index}>
            <div className="directory-container">
              <span className="directory-name">{node.name}</span>
            </div>
            <ul className="sub-tree">{renderTree(node.children)}</ul>
          </div>
        );
      } else {
        return (
          <li key={index} className="file-item">
            <span className="file-name">{node.name}</span>
            <Button onClick={() => onDownloadFile(node.url, node.name)}>
              Download
            </Button>
          </li>
        );
      }
    });
  };
  return <ul className="file-tree">{renderTree(files)}</ul>;
};

const buildFileTree = (files) => {
  const root = {
    type: 'directory',
    name: '/',
    children: []
  };

  files.forEach(file => {
    const parts = file.url.split('/');
    let currentNode = root;

    parts.forEach((part, index) => {
      if (part) {
        const isLastPart = index === parts.length - 1;
        const existingNode = currentNode.children.find(child => child.name === part);

        if (existingNode) {
          if (isLastPart) {
            // Update the existing directory node to a file node
            existingNode.type = 'file';
            existingNode.url = file.url;
          } else {
            // Traverse down the tree
            currentNode = existingNode;
          }
        } else {
          if (isLastPart) {
            // Add a new file node
            currentNode.children.push({
              type: 'file',
              name: part,
              url: file.url
            });
          } else {
            // Add a new directory node and traverse down the tree
            const newNode = {
              type: "directory",
              name: part,
              children: [],
            };
            currentNode.children.push(newNode);
            currentNode = newNode;
          }
        }
      }
    });
  });

  return root.children;
};

const FileViewer = ({title}) => {
    const [files, setFiles] = useState([]);
    const dispatch = useDispatch();
    const response = useGetMediaFiles();
    useEffect(() => {
        if (response) {
          // Build a tree structure from the response
          const tree = buildFileTree(response);
          setFiles(tree);
        }
    }, [response]);

    const downloadFile = (url, fileName) => {
      dispatch(setSnackbar('Download started.', 'Notification', true, 7000));
    
      // Create an anchor tag and click it to start the download
      const a = document.createElement("a");
      a.href = url; // Directly use the URL
      a.download = fileName;
      a.target = "_blank";
      a.rel = "noreferrer";
      a.style.display = "none";
    
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    return (
        <div className="file-viewer">
          <h1>{title}</h1>
          <h5><b>Note:</b> We only support downloading one file at a time.</h5>
          <FileTree files={files} onDownloadFile={downloadFile} />
        </div>
    );
};

export default FileViewer;
